import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { IconButton, type IIconButtonProps } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import {
  type IShortLinkMergeFieldAction,
  type IShortLinkUrlEditorFactory,
} from 'entities/ShortLink/api/types'

type IShortenLinkIconActionProps = {
  onAddShortLink: (link: string) => void
  iconButtonProps?: IIconButtonProps
  mergeFieldAction?: IShortLinkMergeFieldAction | null
  urlEditorFactory?: IShortLinkUrlEditorFactory | null
}

export const ShortenLinkIconAction: FC<IShortenLinkIconActionProps> = observer(
  ({ onAddShortLink, iconButtonProps, mergeFieldAction, urlEditorFactory }) => {
    const { shortLinkStore } = useEntitiesContext()
    const onOpenShortenLinkModal = () => {
      shortLinkStore.onOpenModal({
        onAddLink: onAddShortLink,
        mergeFieldAction,
        urlEditorFactory,
      })
    }
    return (
      <IconButton
        icon={'link'}
        tooltipProps={{
          label: 'Shorten URL',
          placement: 'top',
        }}
        color={'tertiary'}
        size={'medium'}
        variant={'icon'}
        onClick={onOpenShortenLinkModal}
        ariaLabel='Shorten_URL'
        {...iconButtonProps}
      />
    )
  }
)
